import React from "react";

export default function NormalText(props) {
  const fontSize = props.fontSize ? props.fontSize : "";
  const color = props.color ? props.color : "";
  const fontFamily = props.fontFamily ? props.fontFamily : "GibsonRegular";
  const fontWeight = props.fontWeight ? props.fontWeight : "normal";
  const pointer = props.cursor ? props.cursor : "";
  return (
    <div
      style={{
        fontFamily: fontFamily,
        fontSize: fontSize,
        color: color,
        fontWeight: fontWeight,
        textAlign: "center",
        cursor: pointer,
      }}
      onClick={props.onClick}
    >
      {props.text ? props.text : props.children}
    </div>
  );
}
